export const email = (email) => {

 
    
    var  Euser = email.substring(0, email.indexOf("@"));
    var  Edom = email !=  '' ? email.substring(email.indexOf("@") + 1, email.length) : '';

    
        if(email.length < 1){
            return { value: false, mess: "O campo email é obrigatório" }
        }else if(Euser.length < 1){
            return { value: false, mess: "Email invalido! Utilize o formato 'seuemail@seudom.com" }
        }else if(email.search("@") ==-1){
            return { value: false, mess: "Adicione '@' no email" }
        }else if(Edom.indexOf(".") < 1 ){
            return { value: false, mess: "Email invalido! Utilize o formato 'seuemail@seudom.com" }
        }else if(Edom.indexOf(".") < 1 ){
            return { value: false, mess: "Email invalido! Utilize o formato 'seuemail@seudom.com" }
        }else{
            return {value: true }
        } 
    
};